angular.module("Khayrokom").controller("MainController",
    ['$scope', '$window', '$rootScope', '$q', 'callService','modalService','Notification','$filter','$cookies','deviceDetector',
    function ($scope, $window, $rootScope, $q, callService,modalService,Notification,$filter,$cookies,deviceDetector) {
        $scope.initTemplate = function () {
            $scope.email="";
            $scope.message="";
            $scope.nextOffsetWeeks = "";
            $scope.prevOffsetWeeks = 0;
            $scope.nextOffsetVideos = "";
            $scope.prevOffsetVideos = 0;
            $scope.nextOffsetHalaqat = "";
            $scope.prevOffsetHalaqat = 0;
            $window.scrollTo(0, 0);
            $rootScope.vedioModal = false;
            $scope.videos=[];
            $rootScope.isDesktopDevice=deviceDetector.isDesktop();
            $rootScope.codeModal=false;
            $rootScope.show = {
                video: false,
                posts: false,
                service: false,
                normal: false
            };
            $scope.template1 = {
                video: false,
                posts: false,
                service: false,
                normal: true
            }
            $scope.template2 = {
                video: true,
                posts: false,
                service: false,
                normal: false
            }
            $scope.template3 = {
                video: false,
                posts: false,
                service: true,
                normal: true
            }
            $scope.template4 = {
                video: false,
                posts: true,
                service: false,
                normal: false
            }
            $scope.arrayOfTemplates = [$scope.template1, $scope.template2, $scope.template3, $scope.template4]
            if($cookies.get('temlate')!=undefined){
                $rootScope.temlate=$cookies.get('temlate')
                $rootScope.id=$cookies.get('id')
                $rootScope.index=$cookies.get('index')
            }
            $scope.selectTemplate($rootScope.temlate);
            if ($rootScope.temlate == 1) {
                $scope.getServiceVideos(0)
            }
            else if ($rootScope.temlate == 2)
                $scope.getServiceHalaqat()
            else if ($rootScope.temlate == 3)
                $scope.getWeeks(0).then(function () {
                    $scope.getWeeksPosts($scope.weeks[0].id)
                })

        }
        $scope.selectTemplate = function (input) {
            $rootScope.show = JSON.parse(JSON.stringify($scope.arrayOfTemplates[input]))
        }
        $scope.getWeeks = function (offset) {
            var q = $q.defer();
            var json = {};
            json.url = 'api/weeks';
            json.data = {}
            json.data.serviceId = $rootScope.id;
            json.data.offset = offset;
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                $scope.weeks = data.data.weeks;
                if (data.data.offset != undefined) {
                    $scope.prevOffsetWeeks = data.data.offset;
                    $scope.nextOffsetWeeks = data.data.offset;
                }
                else {
                    $scope.nextOffsetWeeks = data.data.offset;
                    $scope.prevOffsetWeeks += 4;
                }
                q.resolve();
            })
            return q.promise;
        }
        $scope.getNextWeeks = function () {
            $scope.getWeeks($scope.prevOffsetWeeks);
        };
        $scope.getPrevWeeks = function () {
            if ($scope.prevOffsetWeeks >= 8) {
                $scope.nextOffsetWeeks = "";
                $scope.prevOffsetWeeks -= 8;

                $scope.getWeeks($scope.prevOffsetWeeks);
            }
        };

        $scope.getWeeksPosts = function (id) {
            var json = {};
            json.url = 'api/week-posts';
            json.data = {};
            json.data.weeksId = id;
            json.method = 'POST';

            callService.ajaxCall(json).then(function (data) {
                if (data.data != undefined) {
                    for (var i = 0; i < data.data.length; i++) {
                        if (data.data[i].image != "")
                            data.data[i].image = 'http://khairokom.gplanet.tech/uploads/' + data.data[i].image
                        else
                            data.data[i].image = require('../../imgs/video-1.jpg')
                    }
                }

                $scope.images = data.data;
            })
        }
        $scope.getServiceVideos = function (offset) {
            var json = {};
            json.url = 'api/service-videos';
            json.data = {};
            json.data.serviceId = $rootScope.id;
            json.data.offset = offset;
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                if (data.data != undefined) {
                    for (var i = 0; i < data.data.videos.length; i++) {
                        if (data.data.videos[i].image != "")
                            data.data.videos[i].image = 'http://khairokom.gplanet.tech/uploads/' + data.data.videos[i].image
                        else
                            data.data.videos[i].image = require('../../imgs/video-1.jpg')
                    }
                }
                if($scope.videos==[])
                    $scope.videos = data.data.videos;
                else
                    for(var i=0;i<data.data.videos.length;i++)
                        $scope.videos.push(data.data.videos[i])
                if (data.data.offset != undefined) {
                    $scope.prevOffsetVideos = data.data.offset;
                    $scope.nextOffsetVideos = data.data.offset;
                }
                else {
                    $scope.nextOffsetVideos = data.data.offset;
                    $scope.prevOffsetVideos += 8;
                }
            })
        }
        $scope.getNextVideos = function () {
            $scope.getServiceVideos($scope.prevOffsetVideos);
        };
        $scope.getPrevVideos = function () {
            if ($scope.prevOffsetVideos >= 16) {
                $scope.nextOffsetVideos = "";
                $scope.prevOffsetVideos -= 16;

                $scope.getServiceVideos($scope.prevOffsetVideos);
            }
        };

        $scope.getServiceHalaqat = function () {
            var json = {};
            json.url = 'api/service-halaqat';
            json.data = {};
            json.data.serviceId = $rootScope.id;
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                if (data.data.halaqat != undefined) {
                    for (var i = 0; i < data.data.halaqat.length; i++) {
                        if (data.data.halaqat[i].image != "")
                            data.data.halaqat[i].image = 'http://khairokom.gplanet.tech/uploads/' + data.data.halaqat[i].image
                        else
                            data.data.halaqat[i].image = require('../../imgs/video-1.jpg')
                    }
                    if(data.data.halaqat.length%4!=0)
                        var jLimit= Math.floor(data.data.halaqat.length/4)+1;
                    else
                        var jLimit= Math.floor(data.data.halaqat.length/4);
                    $scope.rowHalaqat={val:[]}
                    for(var i=0;i<jLimit;i++)
                        $scope.rowHalaqat.val.push([]);
                    var j=0
                    for(var i=0 ;i<data.data.halaqat.length;i++){
                        if(i%4==0&&i!=0)
                            j++;
                        $scope.rowHalaqat.val[j].push(data.data.halaqat[i])
                    }
                }
            })
        }
        $scope.openHalaqaModal=function (id) {
            $scope.halaqaId=id;
            $scope.code="";
            $scope.externalLink='';
            var modalInstance = modalService.createModal(require('../../views/modals/halaqaModal.html'), 'MainController', $scope);
            modalService.setCurrentModal(modalInstance);
            $rootScope.codeModal=true;
        }
        $scope.openPicModal=function (input) {
            $scope.urlPath=input;
            var modalInstance = modalService.createModal(require('../../views/modals/picModal.html'), 'MainController', $scope);
            modalService.setCurrentModal(modalInstance);
            $rootScope.codeModal=true;
        }
        $rootScope.openErrorModal=function () {
            var modalInstance = modalService.createModal(require('../../views/modals/errorModal.html'), 'HomeController', $rootScope);
            modalService.setCurrentModal(modalInstance);
            $rootScope.codeModal=true;
        }
        $scope.verifyCode=function (code) {
            var json = {};
            json.url = 'api/verify-code';
            json.data = {};
            json.data.halaqaId = $scope.halaqaId;
            try{
                if(code==""||code.trim().length==0){
                    Notification.warning({message: $filter('translate')('EMPTY_CODE'), delay: 5000});
                    return
                }
            }catch (s){}
            json.data.code= code;
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                $scope.externalLink = "http://e-learning.qj.org.sa/liveclasses";
                return;
                if(data.data.link.split("http://")[1]==undefined){
                    $scope.externalLink="http://"+data.data.link;
                }
                else{
                    $scope.externalLink=data.data.link;
                }
            },function () {
                $scope.closeModal()
                $rootScope.openErrorModal();


            })
        }
        $scope.sendEmail=function () {
            var json = {};
            json.url = 'api/send-mail';
            json.data = {};
            try{
            if($scope.email==""||$scope.email.trim().length==0){
                Notification.warning({message: $filter('translate')('EMPTY_EMAIL'), delay: 5000});
                return
            }
            }catch (s){}
            if(!($scope.email.includes("@")&&$scope.email.includes(".")&&$scope.email.length>=5)){
                Notification.warning({message: $filter('translate')('ERROR_EMAIL'), delay: 5000});
                return
            }
            try{
            if($scope.message==""||$scope.message.trim().length==0){
                Notification.warning({message: $filter('translate')('EMPTY_MESSAGE'), delay: 5000});
                return
            }
            }catch (s){}

            json.data.email= $scope.email;
            json.data.message= $scope.message;
            json.method = 'POST';
            json.showNotifcation="";
            callService.ajaxCall(json).then(function (data) {
                $scope.email="";
                $scope.message="";
            })
        }
        $scope.teachingStuff = function () {
            var json = {};
            json.url = 'api/teaching-stuff';
            json.data = {};
            json.method = 'POST';
            $rootScope.stuff=[]
            callService.ajaxCall(json).then(function (data) {
                if (data.data != undefined) {
                    for (var i = 0; i < data.data.length; i++) {
                        if (data.data[i].image != "")
                            data.data[i].image = 'http://khairokom.gplanet.tech/uploads/' + data.data[i].image
                        else
                            data.data[i].image = require('../../imgs/video-1.jpg')
                    }
                }

                $rootScope.stuff = data.data;
            })
        }
        $scope.structure=function () {
            var json = {};
            json.url = 'api/structure';
            json.data = {};
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                if (data.data != undefined) {
                    for (var i = 0; i < data.data.length; i++) {
                        if (data.data[i].image != "")
                            data.data[i].image = 'http://khairokom.gplanet.tech/uploads/' + data.data[i].image
                        else
                            data.data[i].image = require('../../imgs/video-1.jpg')
                    }
                }
                $scope.structure= data.data;
            })
        }
        $scope.managment_board=function () {
            var json = {};
            json.url = 'api/structure';
            json.data = {};
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                if (data.data != undefined) {
                    for (var i = 0; i < data.data.length; i++) {
                        if (data.data[i].image != "")
                            data.data[i].image = 'http://khairokom.gplanet.tech/uploads/' + data.data[i].image
                        else
                            data.data[i].image = require('../../imgs/video-1.jpg')
                    }
                }
                $scope.board= data.data;
            })
        }
        $scope.getConsulting=function () {
            var json = {};
            json.url = 'api/consulting-committee';
            json.data = {};
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                if (data.data != undefined) {
                    for (var i = 0; i < data.data.length; i++) {
                        if (data.data[i].image != "")
                            data.data[i].image = 'http://khairokom.gplanet.tech/uploads/' + data.data[i].image
                        else
                            data.data[i].image = require('../../imgs/video-1.jpg')
                    }
                }
                $scope.consultingCommitee=data.data;
            })
        };
        $scope.closeModal = function () {
            var modalInstance = modalService.getCurrentModal();
            modalInstance.close();
            $rootScope.vedioModal=false;
            $rootScope.codeModal=false;
        };
        $scope.getAbout=function () {
            var json = {};
            json.url = 'api/about';
            json.data = {};
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                $scope.allAboutData=data.data;
            })
        }
    }]);



// WEBPACK FOOTER //
// ./js/controllers/MainController.js